import React, {Component} from 'react'
import Styles from './WeekPayment.module.css'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../../componentes/DateUtilities'
import {Dropdown, Input} from 'semantic-ui-react'
import Single from '../../../componentes/Single'
import moment from 'moment'
import WeekTable from './weekTable'
import Agregar from '../agregar/index'
import Rechazos from '../rechazos/index'

export default class PiscaEmpleados extends Component{
    constructor(props){
        super(props)
        this.state={
            pagos:[],
            dateFilter:'mes',
            firstDate:'',
            firstDateStr:'',
            secondDate:'',
            secondDateStr:'',
            employee:'',
            totalPisca: 0,
            sector:"",
            alert:"",
        }
        this.unsubscribe=null
    }
    setReference=()=>{
        let dbReference=firebase.firestore().collection('Produccion')
        dbReference=this.filterByEmployee(dbReference)
        dbReference=this.filterBySector(dbReference)
        dbReference=this.filterByDate(dbReference)
        return dbReference
    }
    filterByEmployee=dbReference=>{
        if(this.state.employee==='' || this.state.employee==='Todos') return dbReference
        return dbReference.where('empleado', '==', this.state.employee)   
    }
    filterBySector=dbReference=>{
        if(this.state.sector==='' || this.state.sector==='Todas') return dbReference
        return dbReference.where('sector', '==', this.state.sector)   
    }
    filterByDate=(dbReference)=>{
        if(this.state.dateFilter==='specificDateRange'){
            if(this.state.firstDate!=='' && this.state.secondDate!==''){
                return this.filterSpecificDates(dbReference)
            }
        }
        if(this.state.dateFilter==='mes'){
            return this.filterEsteMes(dbReference)
        }
        return dbReference
    }
    filterEsteMes=dbReference=>{
        let first = DateUtilities.getFirstDayOfMonth()
        return dbReference.where('fecha', '>=', first)
    }
    filterSpecificDates=dbReference=>{
        return dbReference.where('fecha', '>=', this.state.firstDate).where('fecha', '<=', DateUtilities.addDays(this.state.secondDate, 1))
    }
    getWeekAndYear=(date)=>{
        let momentDate=moment(date)
        let dayOfTheWeek=momentDate.day()
        let year=momentDate.year()
        let week=dayOfTheWeek>=4 
            ? moment(DateUtilities.addDays(date, 3)).week()
            : momentDate.week() 
        return`${week} ${year}`
    }
    helpClick=()=>{
        alert(this.state.alert)
    }
    GetData=()=>{
		this.unsubscribe=this.setReference().orderBy('fecha','desc').onSnapshot(pagos=>{
            try{
                const pagosArray=[]
                let weekIndex=-1
                let empleadosIndexMap={}
                for(let i=0; i<pagos.size;i++){
                    const pago=pagos.docs[i]
                    const date=pagos.docs[i].data().fecha.toDate()
                    const weekAndYear=this.getWeekAndYear(date)
                    if(pagosArray.length===0 || pagosArray[weekIndex].weekAndYear!==weekAndYear){
                        pagosArray.push({weekAndYear:weekAndYear, employees:[], total:0})
                        weekIndex++
                        empleadosIndexMap={}
                    }
                    const employee=pago.data().empleado
                    if(empleadosIndexMap[employee]===undefined){
                        pagosArray[weekIndex].employees.push({
                            employee:employee,
                            totalEmpleado:0,
                            activities:[],
                            harvestActivities:[],
                        })
                        empleadosIndexMap[employee]=pagosArray[weekIndex].employees.length-1   
                    }
                    if(pago.data().fruta === "Frambuesa"){
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].totalEmpleado+=pago.data().totalBotes/2
                        pagosArray[weekIndex].total+=pago.data().totalBotes/2
                    } else if (pago.data().fruta === "Zarzamora"){
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].totalEmpleado+=pago.data().totalCajas
                        pagosArray[weekIndex].total+=pago.data().totalCajas
                    } else {
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].totalEmpleado=0
                        pagosArray[weekIndex].total=0
                    }

                    if(pago.data().fruta==='Zarzamora'){
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].harvestActivities.push({
                            id:pago.id,
                            fruta:pago.data().fruta,
                            variedad:pago.data().variedad,
                            sector:pago.data().sector,
                            fecha:pago.data().fecha.toDate().toLocaleDateString(),
                            estado:pago.data().estado,
                            totalCajas:pago.data().totalCajas,
                            cajas6:pago.data().cajas6,
                            cajas12:pago.data().cajas12,
                            cajas18:pago.data().cajas18,
                            cajas6Precio:pago.data().cajas6Precio,
                            cajas12Precio:pago.data().cajas12Precio,
                            cajas18Precio:pago.data().cajas18Precio,
                        })
                    }else{
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].activities.push({
                            id:pago.id,
                            fruta:pago.data().fruta,
                            variedad:pago.data().variedad,
                            sector:pago.data().sector,
                            fecha:pago.data().fecha.toDate().toLocaleDateString(),
                            estado:pago.data().estado,
                            totalBotes:pago.data().totalBotes,
                            totalCajas:pago.data().totalBotes/2
                        })
                    }
                }
                this.setState({
                    pagos:pagosArray,
                    totalPisca: pagosArray.reduce((suma, currentValue) => suma = suma + currentValue.total,0),
                })
            }
            catch(e){
                console.log(e)
            }
        })
    }
    handleDateFilterChange=(e, {value})=>{
        this.setState({dateFilter:value})
    }
    handleSpecificDateChange=(e, {name, value})=>{
        const date=DateUtilities.parseDate(value)
        this.setState({
            [name]:date,
            [name+'Str']:value
        })
    }
    handleSectorChange=(e, {value})=>{
        this.setState({sector:value})
    }
    handleEmployeeChange=(e, {value})=>{
        this.setState({employee:value})
    }
    componentDidMount(){
        this.GetData()
    }
    componentDidUpdate(prevProps, prevState){
        let filtersHaveChanged=false
        if(this.state.dateFilter!==prevState.dateFilter && this.state.dateFilter!=='specificDateRange'){
            filtersHaveChanged=true
        }
        if(this.state.sector!==prevState.sector)
            filtersHaveChanged=true
        if(this.state.employee!==prevState.employee)
            filtersHaveChanged=true
        if(this.state.firstDate!== prevState.firstDate && this.state.secondDate!=='')
            filtersHaveChanged=true
        if(this.state.secondDate!==prevState.secondDate && this.firstDate!=='')
            filtersHaveChanged=true
        if(filtersHaveChanged){
            this.unsubscribe()
            this.GetData()
        }
    }
    render(){
        return(
            <section className={Styles.pagos}>

                <div className={Styles.titleRow}>
                    <h2>Pisca Total = {this.state.totalPisca}</h2>
                    <div className={Styles.filterActions}>
                        <Agregar />
                        <Rechazos />
                    </div>
                </div>
                <div className={Styles.filtros}>
                    <div className={Styles.input}>
                        <Dropdown
                            fluid
                            selection
                            options={[
                                {key:1, text:'Este Mes', value:'mes'},
                                {key:2, text:'Fechas específicas', value:'specificDateRange'},
                            ]}
                            name='dateFilter'
                            value={this.state.dateFilter}
                            onChange={this.handleDateFilterChange}
                        />
                    </div>
                    {
                        this.state.dateFilter==='specificDateRange'
                        ?
                        <>
                        <div className={Styles.input}>
                            <h3>Del</h3>
                            <Input
                                type='date'
                                value={this.state.firstDateStr}
                                name='firstDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        <div className={Styles.input}>
                            <h3>Al</h3>
                            <Input
                                type='date'
                                value={this.state.secondDateStr}
                                name='secondDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        </>
                        :null
                    }
                    <div className={Styles.input}>
                        <Single 
                            tabla='Zonas' 
                            columna='sector'
                            placeholder='Zonas' 
                            value={this.state.sector}
                            onChange={this.handleSectorChange} 
                            incluir={["Todas"]}
                        />
                    </div>
                    <div className={Styles.input}>
                        <Single 
                            filtro1='activo' 
                            filtro2='=='
                            filtro3='si'
                            tabla='Empleados' 
                            columna='Nombre'
                            placeholder='Empleados' 
                            value={this.state.employee} 
                            onChange={this.handleEmployeeChange} 
                            all={1} 
                            incluir={["Todos"]}
                        />
                    </div>
                </div>
                {
                    this.state.pagos.map((week, i)=>{
                        return <WeekTable key={i} week={week} fruta={this.state.pagos}/>
                    })
                }
            </section>
        )
    }
}
